import BunkeyAPI from './BunkeyAPI'



export const getBreadCrumbWithChildren = (workclient) => {

    return BunkeyAPI({
        url: `clients/${workclient}/folderswithchildren`,
        method: 'get',

    })
}

export const fetchUsersToMention = (workclient, objectId) => {

    return BunkeyAPI({
        url: `/clients/${workclient}/objects/${objectId}/usersToComment?onlyGroups=${true}`,
        method: 'GET',
    })
}

export const fetchUsersToMentionFalse = (workclient, objectId) => {
  return BunkeyAPI({
      url: `/clients/${workclient}/objects/${objectId}/usersToComment?onlyGroups=${false}`,
      method: 'GET',
  })
}
export const fetchUsersToMentionByAssets = (workclient, objects) => {

    return BunkeyAPI({
        url: `/clients/${workclient}/users/belongsobjects`,
        method: 'POST',
        data: {
            "object": objects
        }
    })
}

export const fetchUsersToMentionAll = (workclient, page) => {
  return BunkeyAPI({
      url: `clients/${workclient}/workspaces?page=${page}`,
      method: 'GET',
  })
}
